export enum DateRangeType {
  TenantWeek = 0,
  SettlementWeek = 1, //fedex
  ReportWeek = 2,
  PayrollWeek = 3,
  PriorWeek = 4,
  ScheduleWeek = 5, //schedule
  PriorMonth = 6,
  IVMRWeek = 7
}

export const DateRangeTypeMapping: Record<DateRangeType, string> = {
  [DateRangeType.TenantWeek]: 'Tenant',
  [DateRangeType.SettlementWeek]: 'Settlement',
  [DateRangeType.ReportWeek]: 'Report',
  [DateRangeType.PayrollWeek]: 'Payroll',
  [DateRangeType.PriorWeek]: 'Prior Week',
  [DateRangeType.ScheduleWeek]: 'Schedule',
  [DateRangeType.PriorMonth]: 'Prior Month',
  [DateRangeType.IVMRWeek]: 'IVMR'
};
